export const API_CAT_DANHMUC = process.env.NEXT_API_DANHMUC;
export const API_CAT = process.env.NEXT_API_CAT;
export const API_CAT_TTHC = process.env.NEXT_API_CAT_TTHC;
export const API_CAT_PAKN = process.env.NEXT_API_CAT_PAKN;
export const API_CAT_AUTH = process.env.NEXT_AUTH_URL;
export const API_CAT_EVL = process.env.NEXT_API_EVL;
